import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ViewWillEnter } from '@ionic/angular';
import { PlatformService, PanAppState } from '@panamax/app-state';
import { ServiceRequestAnalyticsService } from '@usf/ngrx-list';
import { take } from 'rxjs/operators';
import { Crumb } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { PATHS } from '@shared/constants/paths';
import { ServiceRequestService } from '@service-request/services/service-request.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-request-credit-confirmation',
  templateUrl: './request-credit-confirmation.page.html',
  styleUrls: ['./request-credit-confirmation.page.scss'],
})
export class RequestCreditConfirmationPage implements ViewWillEnter {
  breadcrumbs: Crumb[];
  userEmail = '';
  constructor(
    private router: Router,
    public panAppState: PanAppState,
    readonly platformService: PlatformService,
    private serviceRequestService: ServiceRequestService,
    private serviceRequestAnalyticsService: ServiceRequestAnalyticsService,
    private translateService: TranslateService,
  ) {}

  async ionViewWillEnter(): Promise<void> {
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.requestCreditConfirmation),
    );
    this.userEmail = await this.getAndCensorEmail();
    this.breadcrumbs = [
      {
        label: 'i18n.breadcrumbs.home',
        url: '/desktop/home',
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.credit',
        url: '/request-credit',
        active: true,
      },
    ];
    const trackingData = this.serviceRequestService.getTrackingData();
    this.serviceRequestAnalyticsService.trackRequestCreditConfirmPageLoad(
      trackingData?.hasPhoto,
      trackingData?.productData,
      trackingData?.orderId,
      trackingData?.hasDocument,
    );
  }

  async getAndCensorEmail() {
    this.panAppState.user$.pipe(take(1)).subscribe(async user => {
      this.userEmail = user.email;
    });
    let temp_string = this.userEmail[0];
    for (let i = 1; i < this.userEmail.length; i++) {
      if (i < this.userEmail.indexOf('@') - 1) {
        temp_string += '*';
      } else {
        temp_string += this.userEmail[i];
      }
    }
    return temp_string;
  }

  onClickSubmitAnother() {
    this.router.navigate([PATHS.REQUEST_CREDIT]);
  }

  onClickReturnHome() {
    this.router.navigate([PATHS.HOME]);
  }
}
